<template>
  <v-layout
    row justify-space-between
    style="padding-left:12px; padding-right:12px;">

    <!-- extra -->
    <v-tooltip top>
      <template #activator="{ on }">
        <v-btn x-large outlined v-on="on"
               style="margin: 8px;"
               @click=" inputs.extra = !inputs.extra ">
          <v-icon large color="#E08000" v-if="inputs.extra">
            mdi-cog
          </v-icon>
          <v-icon large color="#888888" v-else>
            mdi-cog-outline
          </v-icon>
        </v-btn>
      </template>
      <div>
        <div v-if="inputs.extra">
          Plate with extra data. <br/>
          No sample collection data. <br/>
          Click to unmark for sample data.
        </div>
        <div v-else>
          Plate with sample collection data. <br/>
          Click to mark as extra.
        </div>
      </div>
    </v-tooltip>

    <!-- failed -->
    <v-tooltip top>
      <template #activator="{ on }">
        <v-btn x-large outlined v-on="on"
               style="margin: 8px;"
               @click=" inputs.failed = !inputs.failed ">
          <v-icon large color="#AA2200" v-if="inputs.failed">
            mdi-alert-remove
          </v-icon>
          <v-icon large color="#888888" v-else>
            mdi-alert-remove-outline
          </v-icon>
        </v-btn>
      </template>
      <div v-if="inputs.failed">
        Plate failed. <br/>
        Data not suitable for analysis. <br/>
        Click to mark not failed.
      </div>
      <div v-else>
        Click to mark plate failed.
      </div>
    </v-tooltip>

    <!-- ready -->
    <v-tooltip top>
      <template #activator="{ on }">
        <v-btn x-large outlined v-on="on" :disabled="inputs.failed"
               style="margin: 8px;"
               @click=" inputs.ready = !inputs.ready ">
          <v-icon large color="#FF4466" v-if="inputs.ready && !inputs.failed">
            mdi-heart
          </v-icon>
          <v-icon large color="#888888" v-else>
            mdi-heart-outline
          </v-icon>
        </v-btn>
      </template>
      <div v-if="inputs.ready">
        Plate is ready for data analysis. <br/>
        Click to mark not ready.
      </div>
      <div v-else>
        Click to mark plate ready.
      </div>
    </v-tooltip>

  </v-layout>
</template>

<script>

	import format from 'string-format'

	export default {
		name: "plate-flags",

		components: {},

		data: function () {
			return {
				inputs: {
					extra: false,
					failed: false,
					ready: false,
				},
			}
		},

		props: {
			value: {type: Object, default: () => null,}
		},

		watch: {
			// value: function () {
			// 	console.debug(format(
			// 		"PlateFlagsComponent.watch.value()\n" + "  value: {0}",
			// 		JSON.stringify(this.value)))
			//
			// 	for (let key in this.inputs) {
			// 		this.inputs[key] = this.value[key]
			// 	}
			// },

			value: {
				handler: function () {
					console.debug(format(
						"PlateFlagsComponent.watch.value:deep()\n" + "  value: {0}",
						JSON.stringify(this.value)))

					this.update_inputs(this.value)
				},
				deep: true, /* без deep изменение value не вызывает обработчик */
			},

			inputs: {
				handler: function (val) {
					console.log(format(
						"PlateFlagsComponent.watch.inputs( {0} )",
						JSON.stringify(this.inputs)))
					this.$emit('input', this.inputs)
				},
				deep: true,
			},
		},

		mounted: function () {
			// маленький костыль для первой отрисовки компонента в диалоге
			this.update_inputs(this.value)
		},

		methods: {
			update_inputs: function (value) {
				for (let key in this.inputs) {
					this.inputs[key] = value[key]
				}
			}
		},
	}
</script>

<style scoped>

</style>